import { GzzFamilyMember } from "../general/GzzFamilyMember";
import { UploadEntity } from "moh-package";

export class ClmClaim {

  // Claim Cause
  SinceYears: number;
  During: number;
  TreatedBy: string;
  TreatedByAddress: string;
  MedicalSummaryDocument: UploadEntity[];
  ProvingDocuments: UploadEntity[];
  TreatedFamilyMembers: GzzFamilyMember[];
  Witnesses: GzzFamilyMember[];
  PersonalLetter: string;

  constructor(data: ClmClaim) {

    Object.assign(this, data);
    if (data) {
      
      if (data.ProvingDocuments) {
        
        if (data.TreatedFamilyMembers) {
          for (var i = 0; i < data.TreatedFamilyMembers.length; i++) {
            this.TreatedFamilyMembers[i] = new GzzFamilyMember(data.TreatedFamilyMembers[i]);
          }
        }
        if (data.Witnesses) {
          for (var i = 0; i < data.Witnesses.length; i++) {
            this.Witnesses[i] = new GzzFamilyMember(data.Witnesses[i]);
          }
        }

      }

    }// end if(data)
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/claim/ClmClaim.ts